import React from 'react'
// libs
import styled from 'styled-components'
// components
import { Select } from 'components/FormElements'
// types
// eslint-disable-next-line no-restricted-imports
import { DatePickerToolbarProps } from '@mui/x-date-pickers/DatePicker/DatePickerToolbar'
// utils
import moment from 'moment'

const Wrapper = styled.div`
  padding: 8px 16px;
`

export const DATE_OPTIONS = [{ value: 'DATE_NOW', label: 'Now' }]
export const DATE_SPECIAL_TYPES = DATE_OPTIONS.map((option) => option.value)

const CustomToolbar: React.FC<DatePickerToolbarProps<any> & any> = (props) => {
  const handleMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  const onMenusStateChange = (value: boolean) => () => props.setMenuOpen(value)

  return (
    <Wrapper onMouseDown={handleMouseDown}>
      <Select
        label='Custom Value'
        options={DATE_OPTIONS}
        menuIsOpen={props.menuOpen}
        handleChange={props.onChange}
        onMenuOpen={onMenusStateChange(true)}
        onMenuClose={onMenusStateChange(false)}
        value={moment.isMoment(props.value) ? null : props.value}
      />
    </Wrapper>
  )
}

export default CustomToolbar
